import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { Button, DetailPageLayout } from 'src/components/common';
import { PeoPayrollProvidersDetailEmployersWrapper } from 'src/components/peoPayrollProvider';
import { ModalId } from 'src/constants/modals';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';
import { useModal } from 'src/hooks/shared';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoPayrollProviderDetailEmployersPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { openModal } = useModal();

  const openInviteEmployersByPeoPpModal = () => {
    openModal(ModalId.InviteEmployersByPeoPp);
  };

  return (
    <DetailPageLayout
      titleContent="Employers"
      topRightContent={
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          size="small"
          onClick={openInviteEmployersByPeoPpModal}
        >
          New
        </Button>
      }
    >
      <TableDataProvider>
        <PeoPayrollProvidersDetailEmployersWrapper peoPayrollProviderId={peoPayrollProviderId} />
      </TableDataProvider>
    </DetailPageLayout>
  );
};
